import React from 'react';
import { CloudIcon, GraphIcon, BarChartIcon, GearIcon, RocketIcon, BoltIcon } from '../components/Icons';
import sapCpiLogo from '../assets/sap-cpi-logo.webp';
import boomiLogo from '../assets/boomi-seeklogo.png';
import powerBiLogo from '../assets/Power-BI.jpg';
import tableauLogo from '../assets/Tableau-Logo.png';
import odooLogo from '../assets/odoo_logo.png';
import sapS4Logo from '../assets/logo_SAP_S4HANA.jpeg';
import awsLogo from '../assets/AWS.png';
import gcpLogo from '../assets/Logo-Google-Cloud.png';
import anthropicLogo from '../assets/anthropic.png';
import langChainLogo from '../assets/LangGraph_LangChain_Icon.png';
import cursorLogo from '../assets/cursor.jpg';

const SERVICES = [
  {
    icon: <CloudIcon />, tag: 'SAP BTP',
    title: 'SAP Integration & BTP',
    desc: 'End-to-end SAP BTP implementation: CPI, API Management, Event Mesh, Cloud Connector and BTP security governance.',
    items: ['SAP CPI iFlow development', 'API Management & OAuth 2.0', 'Event Mesh streaming', 'BTP security & roles', 'Cloud Connector setup', '24x7 monitoring'],
    logos: [{ src: sapCpiLogo, alt: 'SAP CPI logo' }],
  },
  {
    icon: <GraphIcon />, tag: 'iPaaS',
    title: 'Integration Modernization',
    desc: 'Migrate legacy point-to-point integrations to API-led architectures using Boomi.',
    items: ['Landscape assessment', 'Boomi migration roadmap', 'Reusable API design', 'Boomi process implementation', 'Integration testing', 'Cutover & hypercare'],
    logos: [{ src: boomiLogo, alt: 'Boomi logo' }],
  },
  {
    icon: <BarChartIcon />, tag: 'Analytics',
    title: 'Data & Analytics',
    desc: 'Transform raw data into executive insights with Power BI, Tableau, and predictive analytics.',
    items: ['Executive KPI dashboards', 'Automated data pipelines', 'Power BI dashboard development', 'Data warehouse setup', 'Predictive analytics modeling', 'Real-time reporting'],
    logos: [
      { src: powerBiLogo, alt: 'Power BI logo', shellClass: 'service-logo-shell--powerbi' },
      { src: tableauLogo, alt: 'Tableau logo', shellClass: 'service-logo-shell--tableau' },
    ],
  },
  {
    icon: <GearIcon />, tag: 'Odoo ERP / S4HANA',
    title: 'ERP & CRM',
    desc: 'Odoo ERP/CRM and S/4 HANA implementation covering sales, service, payments, dispute resolution and knowledge-base workflows.',
    items: ['Odoo ERP implementation', 'CRM & sales workflows', 'Payment operations', 'Dispute & case management', 'Customer portal', 'Integrations & reporting'],
    logos: [
      { src: odooLogo, alt: 'Odoo logo', shellClass: 'service-logo-shell--odoo' },
      { src: sapS4Logo, alt: 'SAP S/4HANA logo', shellClass: 'service-logo-shell--s4hana' },
    ],
  },
  {
    icon: <RocketIcon />, tag: 'AWS / GCP',
    title: 'Cloud Engineering',
    desc: 'Cloud-native development with AWS, React, Node.js, Python, mobile apps, microservices and AI-assisted solutions.',
    items: ['React / Next.js web apps', 'Mobile (React Native)', 'Microservices & APIs', 'AWS cloud deployment', 'CI/CD pipelines', 'AI-assisted features'],
    logos: [
      { src: awsLogo, alt: 'AWS logo', shellClass: 'service-logo-shell--aws' },
      { src: gcpLogo, alt: 'Google Cloud logo', shellClass: 'service-logo-shell--gcp' },
    ],
  },
  {
    icon: <BoltIcon />, tag: 'AI / ML',
    title: 'AI, ML & Generative AI',
    desc: 'Accelerate innovation with intelligent technologies using AI/ML models, GenAI solutions, and enterprise-ready deployment.',
    items: ['AI & ML model development', 'MLOps and model lifecycle management', 'Generative AI and LLM solutions', 'Conversational AI and intelligent agents', 'Predictive and prescriptive analytics', 'Document AI and intelligent automation'],
    logos: [
      { src: anthropicLogo, alt: 'Anthropic logo', shellClass: 'service-logo-shell--anthropic' },
      { src: langChainLogo, alt: 'LangChain and LangGraph logo', shellClass: 'service-logo-shell--langchain' },
      { src: cursorLogo, alt: 'Cursor logo', shellClass: 'service-logo-shell--cursor' },
    ],
  },
];

export default SERVICES;
